var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "m-subheader" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "mr-auto" }, [
            _c(
              "ul",
              { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
              [
                _c(
                  "li",
                  { staticClass: "m-nav__item" },
                  [
                    _c("router-link", { attrs: { to: { name: "home" } } }, [
                      _c("span", { staticClass: "m-nav__link-text" }, [
                        _c("i", { staticClass: "m-nav__link-icon la la-home" })
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__separator" }, [
                  _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__item" }, [
                  _c("span", { staticClass: "m-nav__link-text" }, [
                    _vm._v(
                      "\n\t\t  \t  \t\t\t\t" +
                        _vm._s(
                          _vm._f("titleize")(
                            _vm._f("translate")("authorizations_administration")
                          )
                        ) +
                        "\n\t\t  \t  \t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__separator" }, [
                  _vm._v("\n\t\t  \t  \t\t>\n\t\t  \t  \t")
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "m-nav__item" }, [
                  _c("span", { staticClass: "m-nav__link-text" }, [
                    _vm._v(
                      "\n\t\t  \t  \t\t\t" +
                        _vm._s(
                          _vm._f("titleize")(
                            _vm._f("translate")("authorizations")
                          )
                        ) +
                        "\n\t\t  \t  \t\t"
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-content", attrs: { id: "content" } }, [
        _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
          _c("div", { staticClass: "m-portlet__head" }, [
            _c("div", { staticClass: "m-portlet__head-caption" }, [
              _c("div", { staticClass: "m-portlet__head-title" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("h3", { staticClass: "m-portlet__head-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("registers"))
                      ) +
                      "\n              "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-portlet__body", attrs: { id: "group-register" } },
            [
              _c(
                "div",
                {
                  staticClass: "form-group m-form__group row container-register"
                },
                [
                  _c(
                    "div",
                    {
                      class: [
                        { "has-danger": _vm.errors.has("authorized_type") },
                        "col-lg-3"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "authorized_type" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("authorized_type")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.autho.authorized_type_id,
                              expression: "autho.authorized_type_id"
                            }
                          ],
                          class: {
                            "form-control": true,
                            error: _vm.errors.has("identification_type")
                          },
                          attrs: {
                            name: "authorized_type",
                            id: "authorized_type",
                            disabled: ""
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.autho,
                                "authorized_type_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.authorized_types, function(auth_type) {
                          return _vm.hideAuthType(auth_type)
                            ? _c(
                                "option",
                                {
                                  key: auth_type.id,
                                  domProps: { value: auth_type.id }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(auth_type.name) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("authorized_type"),
                              expression: "errors.has('authorized_type')"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("authorized_type")) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.idx_department != -1
                    ? _c(
                        "div",
                        {
                          class: [
                            { "has-danger": _vm.errors.has("department_auth") },
                            "col-lg-3"
                          ]
                        },
                        [
                          _c("label", { attrs: { for: "department_auth" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("department")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.autho.department_id,
                                  expression: "autho.department_id"
                                }
                              ],
                              class: {
                                "form-control": true,
                                error: _vm.errors.has("department_auth")
                              },
                              attrs: {
                                name: "department_auth",
                                id: "department_auth"
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.autho,
                                    "department_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")("select_an_option")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.departments, function(department) {
                                return _c(
                                  "option",
                                  {
                                    key: department.id,
                                    domProps: { value: department.id }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(department.name) +
                                        "\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("department_auth"),
                                  expression: "errors.has('department_auth')"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("department_auth")) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        { "has-danger": _vm.errors.has("access_profile") },
                        "col-lg-3"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "access_profile" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("access_profile")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.autho.access_profile_id,
                              expression: "autho.access_profile_id"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "form-control": true,
                            error: _vm.errors.has("identification_type")
                          },
                          attrs: {
                            name: "access_profile",
                            id: "access_profile"
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.autho,
                                  "access_profile_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                _vm.showAccessProfile
                                _vm.changeAccesProfile(
                                  _vm.autho.access_profile_id
                                )
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(
                              _vm._s(_vm._f("capitalize")("select_an_option"))
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.access_profiles.filter(function(
                              access_profile
                            ) {
                              return (
                                access_profile.is_personalized === 0 ||
                                access_profile.id ===
                                  _vm.autho.access_profile_id
                              )
                            }),
                            function(access_profile) {
                              return _c(
                                "option",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.autho.authorized_type_id ===
                                          access_profile.authorized_type_id &&
                                        _vm.autho.department_id ===
                                          access_profile.department_id,
                                      expression:
                                        "autho.authorized_type_id === access_profile.authorized_type_id && autho.department_id === access_profile.department_id"
                                    }
                                  ],
                                  key: access_profile.id,
                                  domProps: { value: access_profile.id }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          access_profile.is_personalized === 0
                                            ? access_profile.name
                                            : "personalized"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.access_profile2.is_personalized === 1 &&
                                    _vm.autho.authorized_type_id ===
                                      _vm.access_profile2.authorized_type_id &&
                                    _vm.autho.department_id ===
                                      _vm.access_profile2.department_id,
                                  expression:
                                    "access_profile2.is_personalized === 1 && autho.authorized_type_id === access_profile2.authorized_type_id && autho.department_id === access_profile2.department_id"
                                }
                              ],
                              domProps: { value: _vm.access_profile2.id }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm._f("capitalize")("personalized")) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.autho.access_profile_personalized == 0
                            ? _c("option", { attrs: { value: "-1" } }, [
                                _vm._v(_vm._s(_vm._f("capitalize")("custom")))
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("access_profile"),
                              expression: "errors.has('access_profile')"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("access_profile")) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.autho.access_profile_id !== "-1",
                          expression: "(autho.access_profile_id !== '-1')"
                        }
                      ],
                      class: [
                        { "has-danger": _vm.errors.has("see_access_profile") },
                        "col-lg-1"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "see_access_profile" } }, [
                        _vm._v(" ")
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-success m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill",
                          attrs: {
                            href: "#",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#access_profile_modal"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.infoModal.apply(null, arguments)
                            }
                          }
                        },
                        [_c("i", { staticClass: "la la-eye" })]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.autho.access_profile_id === "-1",
                          expression: "(autho.access_profile_id === '-1')"
                        }
                      ],
                      staticClass: "col-lg-3 element-register"
                    },
                    [
                      _c("label", [_vm._v(" ")]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-success m-btn m-btn--icon m-btn--wide",
                          attrs: {
                            href: "#",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#access_profile_modal"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showAccessProfileModal.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "la la-calendar" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("capitalize")("access_data"))
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.complete && _vm.hideVisitor
                ? _c(
                    "div",
                    { staticClass: "form-group m-form__group text-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "m-content select-container" },
                        [
                          _c("s-select2", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              name: "select_visited",
                              id: "select_visited",
                              placeholder: "select_visited",
                              data: _vm.select2_array,
                              clear_select: _vm.clear_select,
                              disabled: true,
                              minimumInput: 3
                            },
                            on: {
                              input: function($event) {
                                return _vm.getDataSelect(
                                  $event,
                                  "select_visited"
                                )
                              }
                            },
                            model: {
                              value: _vm.visited_to,
                              callback: function($$v) {
                                _vm.visited_to = $$v
                              },
                              expression: "visited_to"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("select_visited"),
                                  expression: "errors.has(`select_visited`)"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("select_visited")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("form", { staticClass: "m-form m-form--state" }, [
          _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
            _c("div", { staticClass: "m-portlet__body" }, [
              _c("div", { staticClass: "form-group m-form__group row" }, [
                _c(
                  "div",
                  {
                    class: [
                      { "has-danger": _vm.errors.has("identification_number") },
                      "col-lg-3"
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "identification_number" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("identification_number")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.autho.identification_number,
                          expression: "autho.identification_number"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|alpha_num|min:4|max:15",
                          expression: "'required|alpha_num|min:4|max:15'"
                        }
                      ],
                      staticClass: "form-control m-input",
                      attrs: {
                        type: "text",
                        "data-vv-as": "identification_number",
                        id: "identification_number",
                        name: "identification_number",
                        placeholder: _vm._f("capitalize")(
                          _vm._f("translate")("enter_identification_number")
                        ),
                        readonly: ""
                      },
                      domProps: { value: _vm.autho.identification_number },
                      on: {
                        keyup: function($event) {
                          return _vm.uniqueIdentificationNumber(
                            _vm.autho.identification_number,
                            _vm.idx
                          )
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.autho,
                            "identification_number",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("identification_number"),
                            expression: "errors.has(`identification_number`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("identification_number")) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-lg-3",
                    class: {
                      "has-danger": _vm.errors.has("identification_type")
                    }
                  },
                  [
                    _c("label", { attrs: { for: "identification_type" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("identification_type")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.autho.identification_type,
                            expression: "autho.identification_type"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        class: {
                          "form-control": true,
                          error: _vm.errors.has("identification_type")
                        },
                        attrs: {
                          "data-vv-as": "identification_type",
                          id: "identification_type",
                          disabled: "",
                          name: "identification_type"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.autho,
                              "identification_type",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("select_an_option")
                                )
                              ) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.identification_types, function(
                          identification
                        ) {
                          return _c(
                            "option",
                            {
                              key: identification.id,
                              domProps: { value: identification.id }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(identification.name) +
                                  "\n                  "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("identification_type"),
                            expression: "errors.has(`identification_type`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("identification_type")) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      { "has-danger": _vm.errors.has("first_name") },
                      "col-lg-3"
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "first_name" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("first_name")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.autho.first_name,
                          expression: "autho.first_name"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|alpha_spaces|min:2|max:50",
                          expression: "'required|alpha_spaces|min:2|max:50'"
                        }
                      ],
                      staticClass: "form-control m-input",
                      attrs: {
                        "data-vv-as": "first_name",
                        type: "text",
                        id: "first_name",
                        name: "first_name",
                        placeholder: _vm._f("capitalize")(
                          _vm._f("translate")("enter_first_name")
                        )
                      },
                      domProps: { value: _vm.autho.first_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.autho, "first_name", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("first_name"),
                            expression: "errors.has(`first_name`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.translateErrorMessage(
                                "first_name",
                                _vm.errors.first("first_name")
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      { "has-danger": _vm.errors.has("last_name") },
                      "col-lg-3"
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "last_name" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("last_name"))
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.autho.last_name,
                          expression: "autho.last_name"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|alpha_spaces|min:2|max:50",
                          expression: "'required|alpha_spaces|min:2|max:50'"
                        }
                      ],
                      staticClass: "form-control m-input",
                      attrs: {
                        "data-vv-as": "last_name",
                        type: "text",
                        id: "last_name",
                        name: "last_name",
                        placeholder: _vm._f("capitalize")(
                          _vm._f("translate")("enter_last_name")
                        )
                      },
                      domProps: { value: _vm.autho.last_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.autho, "last_name", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("last_name"),
                            expression: "errors.has(`last_name`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.translateErrorMessage(
                                "last_name",
                                _vm.errors.first("last_name")
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.is_cayena === "true" && _vm.autho.authorized_type_id === 1
                ? _c("div", { staticClass: "form-group m-form__group row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-3",
                        class: { "has-danger": _vm.errors.has("genre") }
                      },
                      [
                        _c("label", { attrs: { for: "genre" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("genre"))
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.autho.genre,
                                expression: "autho.genre"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              "form-control": true,
                              error: _vm.errors.has("genre")
                            },
                            attrs: {
                              "data-vv-as": "genre",
                              id: "genre",
                              name: "genre"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.autho,
                                  "genre",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("select_an_option")
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.genres, function(option, index) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  domProps: { value: option.name }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(option.name) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("genre"),
                                expression: "errors.has(`genre`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.errors.first("genre")) + " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-3",
                        class: { "has-danger": _vm.errors.has("blood_type") }
                      },
                      [
                        _c("label", { attrs: { for: "blood_type" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("blood_type")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.autho.blood_type,
                                expression: "autho.blood_type"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              "form-control": true,
                              error: _vm.errors.has("blood_type")
                            },
                            attrs: {
                              "data-vv-as": "blood_type",
                              id: "blood_type",
                              name: "blood_type"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.autho,
                                  "blood_type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("select_an_option")
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.blood_types, function(option, index) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  domProps: { value: option.name }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(option.name) +
                                      "\n                  "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("blood_type"),
                                expression: "errors.has(`blood_type`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.errors.first("blood_type")) + " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("address") },
                          "col-lg-3"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "address" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("address")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.autho.address,
                              expression: "autho.address"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:2|max:50",
                              expression: "'required|min:2|max:50'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            "data-vv-as": "address",
                            type: "text",
                            id: "address",
                            name: "address",
                            placeholder: _vm._f("capitalize")(
                              _vm._f("translate")("enter_address")
                            )
                          },
                          domProps: { value: _vm.autho.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.autho,
                                "address",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("address"),
                                expression: "errors.has(`address`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "address",
                                    _vm.errors.first("address")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("neighborhood") },
                          "col-lg-3"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "neighborhood" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("neighborhood")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.autho.neighborhood,
                              expression: "autho.neighborhood"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:2|max:50",
                              expression: "'required|min:2|max:50'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            "data-vv-as": "neighborhood",
                            type: "text",
                            id: "neighborhood",
                            name: "neighborhood",
                            placeholder: _vm._f("capitalize")(
                              _vm._f("translate")("enter_neighborhood")
                            )
                          },
                          domProps: { value: _vm.autho.neighborhood },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.autho,
                                "neighborhood",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("neighborhood"),
                                expression: "errors.has(`neighborhood`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "neighborhood",
                                    _vm.errors.first("neighborhood")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group m-form__group row" }, [
                _c(
                  "div",
                  {
                    class: [
                      { "has-danger": _vm.errors.has("start_date") },
                      "col-lg-3"
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "start_date" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("start_date")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("s-date-time-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        id: "start_date",
                        name: "start_date",
                        options: _vm.config.start,
                        placeholder: "AAAA-MM-DD"
                      },
                      on: {
                        empty: function($event) {
                          _vm.autho.start_date = $event
                        },
                        input: function($event) {
                          return _vm.startDate(_vm.autho.start_date)
                        }
                      },
                      model: {
                        value: _vm.autho.start_date,
                        callback: function($$v) {
                          _vm.$set(_vm.autho, "start_date", $$v)
                        },
                        expression: "autho.start_date"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("start_date"),
                            expression: "errors.has(`start_date`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.errors.first("start_date")) + " "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.autho.authorized_type_id !== 2 &&
                          _vm.autho.authorized_type_id !== 3 &&
                          _vm.autho.undefined_date == 1,
                        expression:
                          "autho.authorized_type_id !== 2 && autho.authorized_type_id !== 3 && autho.undefined_date == 1"
                      }
                    ],
                    staticClass: "col-lg-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "m-checkbox-inline m-checkbox-inline-form-wizard"
                      },
                      [
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "m-checkbox checkbox-form-wizard" },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm._f("capitalize")("undefined_date")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.autho.undefined_date,
                                  expression: "autho.undefined_date"
                                }
                              ],
                              attrs: { type: "checkbox", name: "undefined" },
                              domProps: {
                                checked: Array.isArray(_vm.autho.undefined_date)
                                  ? _vm._i(_vm.autho.undefined_date, null) > -1
                                  : _vm.autho.undefined_date
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.autho.undefined_date,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.autho,
                                          "undefined_date",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.autho,
                                          "undefined_date",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.autho, "undefined_date", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span")
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.autho.undefined_date
                  ? _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("end_date") },
                          "col-lg-3"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "end_date" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("end_date")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("s-date-time-picker", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            id: "end_date",
                            name: "end_date",
                            options: _vm.config.end,
                            placeholder: "AAAA-MM-DD"
                          },
                          on: {
                            empty: function($event) {
                              _vm.autho.end_date = $event
                            },
                            input: function($event) {
                              return _vm.endDate(_vm.autho.end_date)
                            }
                          },
                          model: {
                            value: _vm.autho.end_date,
                            callback: function($$v) {
                              _vm.$set(_vm.autho, "end_date", $$v)
                            },
                            expression: "autho.end_date"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("end_date"),
                                expression: "errors.has(`end_date`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.errors.first("end_date")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      { "has-danger": _vm.errors.has("email") },
                      "col-lg-3"
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "email" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("email"))
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.autho.email,
                          expression: "autho.email"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.is_operator
                            ? "required|email|max:100|uniqueEmail"
                            : _vm.autho.biometric
                            ? "required|email|max:100|uniqueEmail"
                            : "email||min:5|max:100|uniqueEmail",
                          expression:
                            "is_operator ? 'required|email|max:100|uniqueEmail' : autho.biometric ? 'required|email|max:100|uniqueEmail' : 'email||min:5|max:100|uniqueEmail'"
                        }
                      ],
                      staticClass: "form-control m-input",
                      attrs: {
                        "data-vv-as": "email",
                        type: "text",
                        id: "email",
                        name: "email",
                        placeholder: _vm._f("capitalize")(
                          _vm._f("translate")("enter_email")
                        ),
                        disabled: _vm.checkdisabled === true
                      },
                      domProps: { value: _vm.autho.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.autho, "email", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("email"),
                            expression: "errors.has(`email`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.translateErrorMessage(
                                "email",
                                _vm.errors.first("email")
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group m-form__group row" }, [
                (_vm.autho.authorized_type_id !== 1 &&
                  _vm.is_cayena === "true") ||
                (_vm.autho.authorized_type_id === 1 && _vm.is_cayena === "true")
                  ? _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("company_origin") },
                          "col-lg-3"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "company_origin" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("company_origin")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.autho.company_origin,
                              expression: "autho.company_origin"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value:
                                _vm.autho.authorized_type_id === 2
                                  ? "min:2|max:100|required"
                                  : "min:2|max:100",
                              expression:
                                "autho.authorized_type_id === 2 ? 'min:2|max:100|required' : 'min:2|max:100'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            "data-vv-as": "company_origin",
                            type: "text",
                            id: "company_origin",
                            name: "company_origin",
                            placeholder: _vm._f("capitalize")(
                              _vm._f("translate")("enter_company_origin")
                            )
                          },
                          domProps: { value: _vm.autho.company_origin },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.autho,
                                "company_origin",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("company_origin"),
                                expression: "errors.has(`company_origin`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "company_origin",
                                    _vm.errors.first("company_origin")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.is_cayena === "true" &&
                          _vm.autho.authorized_type_id === 1,
                        expression:
                          "is_cayena === 'true' && autho.authorized_type_id === 1"
                      }
                    ],
                    class: [
                      { "has-danger": _vm.errors.has("autho.position") },
                      "col-lg-3"
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "position" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("position"))
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.autho.position,
                          expression: "autho.position"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "alpha_spaces|min:3|max:50",
                          expression: "'alpha_spaces|min:3|max:50'"
                        }
                      ],
                      staticClass: "form-control m-input",
                      attrs: {
                        "data-vv-as": "position",
                        type: "text",
                        id: "position",
                        name: "position",
                        placeholder: ""
                      },
                      domProps: { value: _vm.autho.position },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.autho, "position", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("autho.position"),
                            expression: "errors.has(`autho.position`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.translateErrorMessage(
                                "position",
                                _vm.errors.first("autho.position")
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      { "has-danger": _vm.errors.has("observations") },
                      "col-lg-6"
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "observations" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("observations")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.autho.observations,
                          expression: "autho.observations"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "min:5|max:200",
                          expression: "'min:5|max:200'"
                        }
                      ],
                      staticClass: "form-control m-input",
                      attrs: {
                        "data-vv-as": "observations",
                        id: "observations",
                        name: "observations",
                        placeholder: _vm._f("capitalize")(
                          _vm._f("translate")("enter_observation")
                        )
                      },
                      domProps: { value: _vm.autho.observations },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.autho,
                            "observations",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("observations"),
                            expression: "errors.has(`observations`)"
                          }
                        ],
                        staticClass: "m-form__help m--font-danger"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.translateErrorMessage(
                                "observations",
                                _vm.errors.first("observations")
                              )
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-3" }, [
                  _c("label", [_vm._v(" ")]),
                  _c("br"),
                  _vm._v(" "),
                  !_vm.is_cargo
                    ? _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.messageCarTooltip,
                              expression: "messageCarTooltip"
                            }
                          ],
                          staticClass:
                            "buttons-actions btn btn-primary m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                          attrs: {
                            href: "",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#add_cars_modal"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-car" }),
                          _vm._v(" "),
                          _vm.own_cars.length > 0
                            ? _c(
                                "span",
                                { staticClass: "badge badge-notification" },
                                [_vm._v(_vm._s(_vm.own_cars.length))]
                              )
                            : _vm._e()
                        ]
                      )
                    : _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.messageTruckTooltip,
                              expression: "messageTruckTooltip"
                            }
                          ],
                          class: [
                            "btn-primary buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill"
                          ],
                          attrs: {
                            href: "",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#add_cargo_cars_modal"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-truck" }),
                          _vm._v(" "),
                          Object.keys(_vm.cargo_cars).length > 0
                            ? _c(
                                "span",
                                { staticClass: "badge badge-notification" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      Object.keys(_vm.cargo_cars).length > 0
                                        ? 1
                                        : ""
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                  _vm._v(" "),
                  _c("label", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shard.allow_credentials_assigned === 1,
                          expression: "shard.allow_credentials_assigned === 1"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.messageCredentialTooltip,
                          expression: "messageCredentialTooltip"
                        }
                      ],
                      class: [
                        { "btn-primary": !_vm.credentialErrors },
                        { "btn-danger": _vm.credentialErrors },
                        "buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill"
                      ],
                      attrs: {
                        href: "",
                        "data-toggle": "modal",
                        "data-backdrop": "static",
                        "data-keyboard": "false",
                        "data-target": "#add_credentials_modal"
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-address-card" }),
                      _vm._v(" "),
                      _vm.authorized_credentials.length > 0
                        ? _c(
                            "span",
                            { staticClass: "badge badge-notification" },
                            [_vm._v(_vm._s(_vm.authorized_credentials.length))]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showExpirations && !_vm.autho.undefined_date,
                          expression: "showExpirations && !autho.undefined_date"
                        }
                      ]
                    },
                    [_vm._v(" ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showExpirations && !_vm.autho.undefined_date,
                          expression: "showExpirations && !autho.undefined_date"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.messageDocumentTooltip,
                          expression: "messageDocumentTooltip"
                        }
                      ],
                      class: [
                        { "btn-primary": !_vm.expirationErrors },
                        { "btn-danger": _vm.expirationErrors },
                        "buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill"
                      ],
                      attrs: {
                        href: "",
                        "data-toggle": "modal",
                        "data-backdrop": "static",
                        "data-keyboard": "false",
                        "data-target": "#add_expiration_modal"
                      }
                    },
                    [_c("i", { staticClass: "fa fa-calendar-times-o" })]
                  ),
                  _vm._v(" "),
                  _vm.is_photo_auth === "true"
                    ? _c("label", [_vm._v(" ")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.is_photo_auth === "true"
                    ? _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.messageImageTooltip,
                              expression: "messageImageTooltip"
                            }
                          ],
                          class:
                            "btn-primary buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill",
                          attrs: {
                            href: "",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#add_picture_modal"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-camera" }),
                          _vm._v(" "),
                          _vm.autho.images.length > 0
                            ? _c(
                                "span",
                                { staticClass: "badge badge-notification" },
                                [_vm._v("1")]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group m-form___group" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group m-form___group row details_container"
                  },
                  [
                    _vm.autho.authorized_type_id !== 1 &&
                    _vm.is_cayena === "false"
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has("company_origin")
                              },
                              "col-lg-3"
                            ]
                          },
                          [
                            _c("label", { attrs: { for: "company_origin" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("company_origin")
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.autho.company_origin,
                                  expression: "autho.company_origin"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value:
                                    _vm.autho.authorized_type_id === 2
                                      ? "min:2|max:100|required"
                                      : "min:2|max:100",
                                  expression:
                                    "autho.authorized_type_id === 2 ? 'min:2|max:100|required' : 'min:2|max:100'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                "data-vv-as": "company_origin",
                                type: "text",
                                id: "company_origin",
                                name: "company_origin",
                                placeholder: _vm._f("capitalize")(
                                  _vm._f("translate")("enter_company_origin")
                                )
                              },
                              domProps: { value: _vm.autho.company_origin },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.autho,
                                    "company_origin",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("company_origin"),
                                    expression: "errors.has(`company_origin`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "company_origin",
                                        _vm.errors.first("company_origin")
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c("label", [_vm._v(" ")]),
                      _c("br"),
                      _vm._v(" "),
                      _vm.is_cargo_prop === 1
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeAuthorization.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "la la-warning" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        "remove_authorization"
                                      )
                                    ) +
                                    "\n                      "
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group m-form___group row" }, [
                  _vm.showVisited
                    ? _c("div", { staticClass: "col-lg-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "m-checkbox-inline m-checkbox-inline-form-wizard"
                          },
                          [
                            _c("label", { staticClass: "m-checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.is_responsible,
                                    expression: "is_responsible"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.is_responsible)
                                    ? _vm._i(_vm.is_responsible, null) > -1
                                    : _vm.is_responsible
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.is_responsible,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.is_responsible = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.is_responsible = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.is_responsible = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("is_responsible")
                                    )
                                  ) +
                                  "\n                      "
                              ),
                              _c("span")
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOperator
                    ? _c(
                        "div",
                        { staticClass: "col-lg-3", attrs: { hidden: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "m-checkbox-list m-checkbox-inline-form-wizard"
                            },
                            [
                              _c("label", { staticClass: "m-checkbox" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.is_operator,
                                      expression: "is_operator"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    disabled: _vm.autho.profile_operator != null
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.is_operator)
                                      ? _vm._i(_vm.is_operator, null) > -1
                                      : _vm.is_operator
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.is_operator,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.is_operator = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.is_operator = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.is_operator = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("is_operator")
                                      )
                                    ) +
                                    "\n                      "
                                ),
                                _c("span")
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOwnFleet
                    ? _c("div", { staticClass: "col-lg-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "m-checkbox-list m-checkbox-inline-form-wizard"
                          },
                          [
                            _c("label", { staticClass: "m-checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.autho.own_fleet,
                                    expression: "autho.own_fleet"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.autho.own_fleet)
                                    ? _vm._i(_vm.autho.own_fleet, null) > -1
                                    : _vm.autho.own_fleet
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.autho.own_fleet,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.autho,
                                            "own_fleet",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.autho,
                                            "own_fleet",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.autho, "own_fleet", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("is_own_fleet")
                                    )
                                  ) +
                                  "\n                      "
                              ),
                              _c("span")
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isTraining && _vm.autho.authorized_type_id !== 3
                    ? _c(
                        "div",
                        { staticClass: "form-control checks col-lg-3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "m-checkbox-list m-checkbox-inline-form-wizard"
                            },
                            [
                              _c("label", { staticClass: "m-checkbox" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.autho.is_telecommuting,
                                      expression: "autho.is_telecommuting"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.autho.is_telecommuting
                                    )
                                      ? _vm._i(
                                          _vm.autho.is_telecommuting,
                                          null
                                        ) > -1
                                      : _vm.autho.is_telecommuting
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.autho.is_telecommuting,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.autho,
                                              "is_telecommuting",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.autho,
                                              "is_telecommuting",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.autho,
                                          "is_telecommuting",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("is_telecommuting")
                                      )
                                    ) +
                                    "\n                      "
                                ),
                                _c("span")
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBiometric,
                          expression: "showBiometric"
                        }
                      ],
                      staticClass: "col-lg-3"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "m-checkbox-list m-checkbox-inline-form-wizard"
                        },
                        [
                          _c("label", { staticClass: "m-checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.autho.biometric,
                                  expression: "autho.biometric"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled: _vm.hasTemplate
                              },
                              domProps: {
                                checked: Array.isArray(_vm.autho.biometric)
                                  ? _vm._i(_vm.autho.biometric, null) > -1
                                  : _vm.autho.biometric
                              },
                              on: {
                                click: function($event) {
                                  return _vm.checkBiometricsMail(
                                    _vm.autho.email
                                  )
                                },
                                change: function($event) {
                                  var $$a = _vm.autho.biometric,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.autho,
                                          "biometric",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.autho,
                                          "biometric",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.autho, "biometric", $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n                      " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("biometric")
                                  )
                                ) +
                                "\n                      "
                            ),
                            _c("span")
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-3" }, [
                _c("label", [_vm._v(" ")]),
                _c("br"),
                _vm._v(" "),
                _vm.autho.own_fleet
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.messageOwnFleetCarTooltip,
                            expression: "messageOwnFleetCarTooltip"
                          }
                        ],
                        class: [
                          { "btn-primary": !_vm.carsErrors },
                          { "btn-danger": _vm.carsErrors },
                          "buttons-actions btn m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill"
                        ],
                        attrs: {
                          href: "",
                          "data-toggle": "modal",
                          "data-backdrop": "static",
                          "data-keyboard": "false",
                          "data-target": "#add_ownfleet_cars_modal"
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-bus" }),
                        _vm._v(" "),
                        _vm.own_fleet_vehicles_selected.length > 0
                          ? _c(
                              "span",
                              { staticClass: "badge badge-notification" },
                              [
                                _vm._v(
                                  _vm._s(_vm.own_fleet_vehicles_selected.length)
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group m-form__group row container-hide" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.is_responsible && _vm.is_cayena === "false",
                          expression: "is_responsible && is_cayena === 'false'"
                        }
                      ],
                      class: [
                        { "has-danger": _vm.errors.has("autho.position") },
                        "col-lg-3"
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "position" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("position")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.autho.position,
                            expression: "autho.position"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_spaces|min:3|max:50",
                            expression: "'alpha_spaces|min:3|max:50'"
                          }
                        ],
                        staticClass: "form-control m-input",
                        attrs: {
                          "data-vv-as": "position",
                          type: "text",
                          id: "position",
                          name: "position",
                          placeholder: ""
                        },
                        domProps: { value: _vm.autho.position },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.autho, "position", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("autho.position"),
                              expression: "errors.has(`autho.position`)"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.translateErrorMessage(
                                  "position",
                                  _vm.errors.first("autho.position")
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.is_operator
                    ? _c(
                        "div",
                        {
                          class: [
                            {
                              "has-danger": _vm.errors.has("profile_operator")
                            },
                            "col-lg-3"
                          ]
                        },
                        [
                          _c("label", { attrs: { for: "profile_operator" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("profile_operator")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.autho.profile_operator,
                                  expression: "autho.profile_operator"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.is_operator ? "required" : "",
                                  expression: "is_operator ?'required' : ''"
                                }
                              ],
                              class: {
                                "form-control m-input": true,
                                error: _vm.errors.has("profile_operator")
                              },
                              attrs: {
                                "data-vv-as": "profile_operator",
                                id: "profile_operator",
                                name: "profile_operator"
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.autho,
                                    "profile_operator",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("select_an_option")
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.profiles, function(profile) {
                                return _c(
                                  "option",
                                  {
                                    key: profile.id,
                                    domProps: { value: profile.id }
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")(profile.name)
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("profile_operator"),
                                  expression: "errors.has(`profile_operator`)"
                                }
                              ],
                              staticClass: "m-form__help m--font-danger"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.translateErrorMessage(
                                      "profile_operator",
                                      _vm.errors.first("profile_operator")
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.is_cargo_prop && _vm.display_departure_order
            ? _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
                _c("div", { staticClass: "m-portlet__body" }, [
                  _c("div", { staticClass: "form-group m-form___group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-2 col-form-label",
                        attrs: { for: "departure_order" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("departure_order")
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.departure_order,
                            expression: "departure_order"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "alpha_num|min:4|max:10",
                            expression: "'alpha_num|min:4|max:10'"
                          }
                        ],
                        staticClass: "form-control m-input",
                        attrs: {
                          type: "text",
                          "data-vv-as": "departure_order",
                          id: "departure_order",
                          name: "departure_order",
                          placeholder: _vm._f("capitalize")(
                            _vm._f("translate")("enter_departure_order")
                          ),
                          readonly: _vm.generate_departure ? false : true
                        },
                        domProps: { value: _vm.departure_order },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.departure_order = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("departure_order"),
                              expression: "errors.has(`departure_order`)"
                            }
                          ],
                          staticClass: "m-form__help m--font-danger"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.translateErrorMessage(
                                  "departure_order",
                                  _vm.errors.first("departure_order")
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.generate_departure
                      ? _c("div", { staticClass: "col-4" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-success",
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.departureOrder.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      "generate_departure_order"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "actions" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.back.apply(null, arguments)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel")))
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.validate.apply(null, arguments)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("save")))
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.autho.access_profile_id !== "" && _vm.autho.access_profile_id !== "-1"
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "access_profile_modal",
                title: _vm._f("capitalize")(
                  _vm._f("translate")("create_access_profile")
                )
              }
            },
            [
              _c("s-access-profile", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modal_access_day,
                    expression: "!modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  data: _vm.access_profile_view,
                  edit_outside: _vm.edit_outside,
                  create_outside: _vm.create_access_days,
                  access_profile_responsible: _vm.access_profile_responsible,
                  create_outside_group: true,
                  view: !_vm.create_access_days,
                  start_date: _vm.autho.start_date,
                  end_date: _vm.autho.end_date,
                  isFromAuth: true,
                  undefined_date: _vm.autho.undefined_date,
                  auth_type: _vm.autho.authorized_type_id
                },
                slot: "body"
              }),
              _vm._v(" "),
              _c("s-access-day", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modal_access_day,
                    expression: "modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  open_outside: !_vm.edit_outside,
                  data: _vm.access_day_view,
                  view: !_vm.edit_outside,
                  create_outside: _vm.create_access_days,
                  modal: "true"
                },
                slot: "body"
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.is_cargo
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "add_cars_modal",
                title: _vm._f("capitalize")(_vm._f("translate")("vehicles")),
                close_header: true,
                size: "modal-sm modal-dialog-centered"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "200"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group m-form__group" },
                        _vm._l(_vm.own_cars, function(car, index) {
                          return _vm.own_fleet_vehicles.find(function(v) {
                            return v.license_plate === car.license_plate
                          }) === undefined || car.license_plate === ""
                            ? _c("div", { key: index, staticClass: "row" }, [
                                _c("div", { staticClass: "col-lg-9" }, [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        {
                                          "has-danger": _vm.errors.has(
                                            "plate_" + index
                                          )
                                        },
                                        "space-row-container"
                                      ]
                                    },
                                    [
                                      _c("label", { attrs: { for: "plate" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")("plate")
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: car.license_plate,
                                            expression: "car.license_plate"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value:
                                              "required|alpha_num|min:6|max:10",
                                            expression:
                                              "'required|alpha_num|min:6|max:10'"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: {
                                          type: "text",
                                          id: "plate_" + index,
                                          "data-vv-as": "plate",
                                          name: "plate_" + index,
                                          placeholder: _vm._f("capitalize")(
                                            _vm._f("translate")("enter_plate")
                                          )
                                        },
                                        domProps: { value: car.license_plate },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              car,
                                              "license_plate",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "plate_" + index
                                              ),
                                              expression:
                                                "errors.has(`plate_${index}`)"
                                            }
                                          ],
                                          staticClass:
                                            "m-form__help m--font-danger"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.translateErrorMessage(
                                                  "plate",
                                                  _vm.errors.first(
                                                    "plate_" + index
                                                  )
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.is_cayena === "true" &&
                                  _vm.autho.authorized_type_id === 1
                                    ? _c(
                                        "div",
                                        {
                                          class: [
                                            {
                                              "has-danger": _vm.errors.has(
                                                "type_vehicle_" + index
                                              )
                                            },
                                            "space-row-container"
                                          ]
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "type_vehicle"
                                                  )
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: car.type_vehicle,
                                                  expression: "car.type_vehicle"
                                                }
                                              ],
                                              staticClass:
                                                "form-control m-input",
                                              attrs: {
                                                name: "type_vehicle_" + index
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    car,
                                                    "type_vehicle",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("capitalize")(
                                                          _vm._f("translate")(
                                                            "select_an_option"
                                                          )
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(_vm.types_car, function(
                                                option,
                                                index
                                              ) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: index,
                                                    domProps: {
                                                      value: option.name
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            _vm._f("translate")(
                                                              option.name
                                                            )
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              })
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "type_vehicle_" + index
                                                  ),
                                                  expression:
                                                    "errors.has(`type_vehicle_${index}`)"
                                                }
                                              ],
                                              staticClass:
                                                "m-form__help m--font-danger"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "type_vehicle_" + index
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-lg-3" }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v(" ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.dropCar(
                                            index,
                                            car.license_plate
                                          )
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-trash" })]
                                  )
                                ])
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.addCar.apply(null, arguments)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-plus" })]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.closeForm }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("close"))
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_ownfleet_cars_modal",
            title: _vm._f("capitalize")(
              _vm._f("translate")("own_fleet_vehicles")
            ),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c(
                "div",
                {
                  staticClass: "m-scrollable",
                  attrs: {
                    "data-scrollbar-shown": "true",
                    "data-scrollable": "true",
                    "data-max-height": "200"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group m-form__group" },
                    _vm._l(_vm.own_fleet_vehicles_selected, function(
                      carown,
                      idx
                    ) {
                      return _c(
                        "div",
                        { staticClass: "row space-down card-container" },
                        [
                          _c("div", { staticClass: "col-lg-9" }, [
                            _c(
                              "div",
                              {
                                class: [
                                  { "has-danger": _vm.errors.has("plate") },
                                  "space-row-container"
                                ]
                              },
                              [
                                _c("label", { attrs: { for: "plate" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("plate")
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: carown.license_plate,
                                        expression: "carown.license_plate"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "own_fleet_cars",
                                      name: "own_fleet_cars",
                                      title: _vm._f("translate")(
                                        "select_an_option"
                                      )
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            carown,
                                            "license_plate",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        function($event) {
                                          return _vm.addCarValue(
                                            carown.license_plate,
                                            idx
                                          )
                                        }
                                      ]
                                    }
                                  },
                                  _vm._l(_vm.own_fleet_vehicles, function(
                                    vehicle,
                                    key
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: key,
                                        domProps: {
                                          value: vehicle.license_plate
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(vehicle.license_plate) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("plate"),
                                        expression: "errors.has(`plate`)"
                                      }
                                    ],
                                    staticClass: "m-form__help m--font-danger"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.translateErrorMessage(
                                            "plate",
                                            _vm.errors.first("plate")
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.is_cayena === "true" &&
                            _vm.authorized_type_id === 1
                              ? _c(
                                  "div",
                                  {
                                    class: [
                                      {
                                        "has-danger": _vm.errors.has(
                                          "type_vehicle"
                                        )
                                      },
                                      "space-row-container"
                                    ]
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")("type_vehicle")
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          },
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.car.type_vehicle,
                                            expression: "car.type_vehicle"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: { name: "type_vehicle" },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.car,
                                              "type_vehicle",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm._f("capitalize")(
                                                  _vm._f("translate")(
                                                    "select_option"
                                                  )
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(_vm.types_car, function(
                                          option,
                                          index
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: { value: option.name }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("capitalize")(
                                                      _vm._f("translate")(
                                                        option.name
                                                      )
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "type_vehicle"
                                            ),
                                            expression:
                                              "errors.has('type_vehicle')"
                                          }
                                        ],
                                        staticClass:
                                          "m-form__help m--font-danger"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors.first("type_vehicle")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-3" }, [
                            _c("label", { attrs: { for: "" } }, [_vm._v(" ")]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.dropCarOwn(
                                      idx,
                                      carown.license_plate
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash" })]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.addCarOwn.apply(null, arguments)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeForm }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("close"))
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.is_cargo
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "add_cargo_cars_modal",
                title: _vm._f("capitalize")(
                  _vm._f("translate")("vehicle_cargo")
                ),
                close_header: true
              }
            },
            [
              _c("section", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "form-group m-form__group row" }, [
                    _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("vehicle_type_id") },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "vehicle_type_id" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("vehicle_type")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cargo_cars.vehicle_type_id,
                                expression: "cargo_cars.vehicle_type_id"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              "form-control": true,
                              error: _vm.errors.has("vehicle_type_id")
                            },
                            attrs: {
                              name: "vehicle_type_id",
                              id: "vehicle_type_id"
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.cargo_cars,
                                    "vehicle_type_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.cargo_vehicles(
                                    _vm.cargo_cars.vehicle_type_id
                                  )
                                }
                              ]
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                _vm._s(_vm._f("capitalize")("select_an_option"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.cargo_vehicle_type, function(
                              cargo_vehicle,
                              idx
                            ) {
                              return _c(
                                "option",
                                {
                                  key: idx,
                                  domProps: { value: cargo_vehicle.id }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(cargo_vehicle.name) +
                                      "\n                "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("vehicle_type_id"),
                                expression: "errors.has(`vehicle_type_id`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "vehicle_type",
                                    _vm.errors.first("vehicle_type_id")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          {
                            "has-danger": _vm.errors.has(
                              "cargo_type_vehicle_type"
                            )
                          },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "cargo_type_vehicle_type" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("vehicle_type")
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cargo_cars.cargo_vehicle_type,
                                expression: "cargo_cars.cargo_vehicle_type"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: {
                              "form-control": true,
                              error: _vm.errors.has("cargo_type_vehicle_type")
                            },
                            attrs: {
                              "data-vv-as": _vm._f("translate")("vehicle_type"),
                              name: "cargo_type_vehicle_type",
                              id: "cargo_type_vehicle_type"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.cargo_cars,
                                  "cargo_vehicle_type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                _vm._s(_vm._f("capitalize")("select_an_option"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.cargo_type_vehicles, function(
                              cargo_vehicle,
                              idx
                            ) {
                              return _vm.hideCargoType(
                                _vm.cargo_cars.vehicle_type_id,
                                cargo_vehicle.type
                              )
                                ? _c(
                                    "option",
                                    {
                                      key: idx,
                                      domProps: { value: cargo_vehicle.name }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              cargo_vehicle.name
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has(
                                  "cargo_type_vehicle_type"
                                ),
                                expression:
                                  "errors.has(`cargo_type_vehicle_type`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "vehicle_type",
                                    _vm.errors.first("cargo_type_vehicle_type")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          {
                            "has-danger": _vm.errors.has("truck_license_plate")
                          },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "truck_license_plate" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("truck_license_plate")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:6|max:10",
                              expression: "'required|min:6|max:10'"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cargo_cars.truck_license_plate,
                              expression: "cargo_cars.truck_license_plate"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            name: "truck_license_plate",
                            id: "truck_license_plate"
                          },
                          domProps: {
                            value: _vm.cargo_cars.truck_license_plate
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cargo_cars,
                                "truck_license_plate",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("truck_license_plate"),
                                expression: "errors.has(`truck_license_plate`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "truck_license_plate",
                                    _vm.errors.first("truck_license_plate")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("cargo_order") },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "cargo_order" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("cargo_order")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cargo_cars.cargo_order,
                              expression: "cargo_cars.cargo_order"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|alpha_num|min:1|max:10",
                              expression: "'required|alpha_num|min:1|max:10'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: { name: "cargo_order", id: "cargo_order" },
                          domProps: { value: _vm.cargo_cars.cargo_order },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cargo_cars,
                                "cargo_order",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("cargo_order"),
                                expression: "errors.has(`cargo_order`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "cargo_order",
                                    _vm.errors.first("cargo_order")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.is_articulate
                      ? _c(
                          "div",
                          {
                            class: [
                              {
                                "has-danger": _vm.errors.has(
                                  "trailer_license_plate"
                                )
                              },
                              "col-lg-6 container-vehicle"
                            ]
                          },
                          [
                            _c(
                              "label",
                              { attrs: { for: "trailer_license_plate" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")(
                                        "trailer_license_plate"
                                      )
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cargo_cars.trailer_license_plate,
                                  expression: "cargo_cars.trailer_license_plate"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:6|max:10",
                                  expression: "'required|min:6|max:10'"
                                }
                              ],
                              staticClass: "form-control m-input",
                              attrs: {
                                name: "trailer_license_plate",
                                id: "trailer_license_plate"
                              },
                              domProps: {
                                value: _vm.cargo_cars.trailer_license_plate
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cargo_cars,
                                    "trailer_license_plate",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "trailer_license_plate"
                                    ),
                                    expression:
                                      "errors.has(`trailer_license_plate`)"
                                  }
                                ],
                                staticClass: "m-form__help m--font-danger"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateErrorMessage(
                                        "trailer_license_plate",
                                        _vm.errors.first(
                                          "trailer_license_plate"
                                        )
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          {
                            "has-danger": _vm.errors.has("cargo_vehicle_brand")
                          },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "cargo_vehicle_brand" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("cargo_vehicle_brand")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cargo_cars.cargo_vehicle_brand,
                              expression: "cargo_cars.cargo_vehicle_brand"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha|min:5|max:20",
                              expression: "'alpha|min:5|max:20'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            "data-vv-as": _vm._f("translate")(
                              "cargo_vehicle_brand"
                            ),
                            name: "cargo_vehicle_brand",
                            id: "cargo_vehicle_brand"
                          },
                          domProps: {
                            value: _vm.cargo_cars.cargo_vehicle_brand
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cargo_cars,
                                "cargo_vehicle_brand",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("cargo_vehicle_brand"),
                                expression: "errors.has(`cargo_vehicle_brand`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "cargo_vehicle_brand",
                                    _vm.errors.first("cargo_vehicle_brand")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          {
                            "has-danger": _vm.errors.has("cargo_vehicle_color")
                          },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "cargo_vehicle_color" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("cargo_vehicle_color")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cargo_cars.cargo_vehicle_color,
                              expression: "cargo_cars.cargo_vehicle_color"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha|min:5|max:20",
                              expression: "'alpha|min:5|max:20'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            "data-vv-as": _vm._f("translate")(
                              "cargo_vehicle_color"
                            ),
                            name: "cargo_vehicle_color",
                            id: "cargo_vehicle_color"
                          },
                          domProps: {
                            value: _vm.cargo_cars.cargo_vehicle_color
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cargo_cars,
                                "cargo_vehicle_color",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("cargo_vehicle_color"),
                                expression: "errors.has(`cargo_vehicle_color`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "cargo_vehicle_color",
                                    _vm.errors.first("cargo_vehicle_color")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          {
                            "has-danger": _vm.errors.has("cargo_vehicle_model")
                          },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "cargo_vehicle_model" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("cargo_vehicle_model")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cargo_cars.cargo_vehicle_model,
                              expression: "cargo_cars.cargo_vehicle_model"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "min:5|max:20",
                              expression: "'min:5|max:20'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            "data-vv-as": _vm._f("translate")(
                              "cargo_vehicle_model"
                            ),
                            name: "cargo_vehicle_model",
                            id: "cargo_vehicle_model"
                          },
                          domProps: {
                            value: _vm.cargo_cars.cargo_vehicle_model
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cargo_cars,
                                "cargo_vehicle_model",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("cargo_vehicle_model"),
                                expression: "errors.has(`cargo_vehicle_model`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "cargo_vehicle_model",
                                    _vm.errors.first("cargo_vehicle_model")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("carrier_company") },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "carrier_company" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("carrier_company")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cargo_cars.carrier_company,
                              expression: "cargo_cars.carrier_company"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "min:5|max:20",
                              expression: "'min:5|max:20'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            "data-vv-as": _vm._f("translate")(
                              "carrier_company"
                            ),
                            name: "carrier_company",
                            id: "carrier_company"
                          },
                          domProps: { value: _vm.cargo_cars.carrier_company },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cargo_cars,
                                "carrier_company",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("carrier_company"),
                                expression: "errors.has(`carrier_company`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "carrier_company",
                                    _vm.errors.first("carrier_company")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          { "has-danger": _vm.errors.has("container_number") },
                          "col-lg-6 container-vehicle"
                        ]
                      },
                      [
                        _c("label", { attrs: { for: "container_number" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("container_number")
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cargo_cars.container_number,
                              expression: "cargo_cars.container_number"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "numeric",
                              expression: "'numeric'"
                            }
                          ],
                          staticClass: "form-control m-input",
                          attrs: {
                            name: "container_number",
                            id: "container_number"
                          },
                          domProps: { value: _vm.cargo_cars.container_number },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.cargo_cars,
                                "container_number",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("container_number"),
                                expression: "errors.has(`container_number`)"
                              }
                            ],
                            staticClass: "m-form__help m--font-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.translateErrorMessage(
                                    "container_number",
                                    _vm.errors.first("container_number")
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        id: "add_cargo_cars_modal"
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("capitalize")("save")) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_credentials_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("credentials")),
            close_header: true,
            size: "modal-sm modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c(
                "div",
                {
                  staticClass: "m-scrollable",
                  attrs: {
                    "data-scrollbar-shown": "true",
                    "data-scrollable": "true",
                    "data-max-height": "200"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group m-form__group" },
                    _vm._l(_vm.authorized_credentials, function(
                      auto_credential,
                      idx
                    ) {
                      return _c("div", { key: idx, staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-9" }, [
                          _c(
                            "div",
                            {
                              class: [
                                {
                                  "has-danger": _vm.errors.has(
                                    "credential_" + idx
                                  )
                                }
                              ]
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: "credential_" + idx } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("credential")
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: auto_credential.credential_id,
                                      expression:
                                        "auto_credential.credential_id"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "validateAccessCredential:" + idx,
                                      expression:
                                        "`validateAccessCredential:${idx}`"
                                    }
                                  ],
                                  class: [
                                    "form-control",
                                    {
                                      error: _vm.errors.has("credential_" + idx)
                                    }
                                  ],
                                  attrs: {
                                    id: "credential_" + idx,
                                    name: "credential_" + idx
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        auto_credential,
                                        "credential_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")(
                                              "select_an_option"
                                            )
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.access_credentials, function(c) {
                                    return _c(
                                      "option",
                                      { key: c.id, domProps: { value: c.id } },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(c.description) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "credential_" + idx
                                      ),
                                      expression:
                                        "errors.has(`credential_${idx}`)"
                                    }
                                  ],
                                  staticClass: "m-form__help m--font-danger"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first("credential_" + idx)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: [
                                {
                                  "has-danger": _vm.errors.has(
                                    "value_credential_" + idx
                                  )
                                }
                              ]
                            },
                            [
                              _c(
                                "label",
                                { attrs: { for: "value_credential_" + idx } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("value_credential")
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: auto_credential.value,
                                    expression: "auto_credential.value"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|numeric|max:15",
                                    expression: "'required|numeric|max:15'"
                                  }
                                ],
                                staticClass: "form-control m-input",
                                attrs: {
                                  "data-vv-as": "credential",
                                  type: "text",
                                  id: "value_credential_" + idx,
                                  name: "value_credential_" + idx,
                                  placeholder: _vm._f("capitalize")(
                                    _vm._f("translate")(
                                      "enter_value_credential"
                                    )
                                  ),
                                  readonly:
                                    parseInt(auto_credential.credential_id) ===
                                    0
                                      ? true
                                      : false
                                },
                                domProps: { value: auto_credential.value },
                                on: {
                                  keyup: function($event) {
                                    return _vm.uniqueCredential(
                                      auto_credential.value,
                                      auto_credential.credential_id,
                                      idx
                                    )
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      auto_credential,
                                      "value",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "value_credential_" + idx
                                      ),
                                      expression:
                                        "errors.has(`value_credential_${idx}`)"
                                    }
                                  ],
                                  staticClass: "m-form__help m--font-danger"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "value_credential_" + idx
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: [
                                {
                                  "has-danger": _vm.errors.has(
                                    "facility_code_" + _vm.idx_car + "_" + idx
                                  )
                                }
                              ]
                            },
                            [
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for:
                                      "facility_code_" + _vm.idx_car + "_" + idx
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm._f("translate")("facility_code")
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value:
                                        _vm.require_facility === "true" &&
                                        auto_credential.credential !==
                                          undefined &&
                                        auto_credential.credential.name ===
                                          "magnetic"
                                          ? "required"
                                          : "",
                                      expression:
                                        "(require_facility === 'true' && auto_credential.credential !== undefined && auto_credential.credential.name === 'magnetic') ? 'required' : ''"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: auto_credential.facility_code,
                                      expression:
                                        "auto_credential.facility_code"
                                    }
                                  ],
                                  class: ["form-control"],
                                  attrs: {
                                    id:
                                      "facility_code_" +
                                      _vm.idx_car +
                                      "_" +
                                      idx,
                                    name:
                                      "facility_code_" + _vm.idx_car + "_" + idx
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          auto_credential,
                                          "facility_code",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function($event) {
                                        return _vm.uniqueCredential(
                                          auto_credential.value,
                                          auto_credential.credential_id,
                                          _vm.idx_car,
                                          auto_credential.facility_code
                                        )
                                      }
                                    ]
                                  }
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm._f("capitalize")(
                                            _vm._f("translate")(
                                              "select_an_option"
                                            )
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.list_facility_code, function(c) {
                                    return _c(
                                      "option",
                                      {
                                        key: c.facility_code,
                                        domProps: { value: c.facility_code }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(c.facility_code) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "facility_code_" +
                                          _vm.idx_car +
                                          "_" +
                                          idx
                                      ),
                                      expression:
                                        "errors.has(`facility_code_${idx_car}_${idx}`)"
                                    }
                                  ],
                                  staticClass: "m-form__help m--font-danger"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.translateErrorMessage(
                                          "credential",
                                          _vm.errors.first(
                                            "credential_" +
                                              _vm.idx_car +
                                              "_" +
                                              idx
                                          )
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-3" }, [
                            _c("label", { attrs: { for: "" } }, [_vm._v(" ")]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-danger m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.dropCredential(idx)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash" })]
                            )
                          ])
                        ])
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-brand m-btn m-btn--icon btn-sm m-btn--icon-only m-btn--pill",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.addCredential.apply(null, arguments)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeForm }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("close"))
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.showExpirations && !_vm.autho.undefined_date
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "add_expiration_modal",
                title: _vm._f("capitalize")(_vm._f("translate")("expirations")),
                close_header: true,
                size: "modal-sm modal-dialog-centered"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-scrollable",
                      attrs: {
                        "data-scrollbar-shown": "true",
                        "data-scrollable": "true",
                        "data-max-height": "200"
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group m-form__group" }, [
                        _c(
                          "div",
                          { staticClass: "form-group m-form__group row" },
                          _vm._l(_vm.doc_types, function(docs, k) {
                            return _c(
                              "div",
                              { key: k, staticClass: "row doc_expiration" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-lg-12",
                                    class: {
                                      "has-danger": _vm.errors.has(
                                        "expires_doc_" + k
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "expires_doc_" + k } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm._f("translate")(
                                                docs.document.name
                                              )
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                     " +
                                        _vm._s(
                                          _vm.expirationDate(_vm.doc_types)
                                        ) +
                                        "\n                     "
                                    ),
                                    _c("s-date-time-picker", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value:
                                            docs.required === 1
                                              ? "required"
                                              : "",
                                          expression:
                                            "docs.required === 1 ? 'required' : ''"
                                        }
                                      ],
                                      attrs: {
                                        options: _vm.config_allow_days.end,
                                        "data-vv-as": docs.document.name,
                                        name: "expires_doc_" + k,
                                        id: "expires_doc_" + k,
                                        alias: docs.document.name,
                                        placeholder: "DD-MM-YYYY"
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.docExpiration(
                                            docs.id,
                                            k,
                                            $event,
                                            docs.document.allowed_days
                                          )
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.autho.doc_auth_types[k].value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.autho.doc_auth_types[k],
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "autho.doc_auth_types[k].value"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "expires_doc_" + k
                                            ),
                                            expression:
                                              "errors.has(`expires_doc_${k}`)"
                                          }
                                        ],
                                        staticClass:
                                          "m-form__help m--font-danger"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "expires_doc_" + k
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.closeForm }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("close")
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "s-modal",
        {
          attrs: {
            id: "add_picture_modal",
            title: _vm._f("capitalize")(_vm._f("translate")("picture_auth")),
            close_header: false,
            size: "modal-lg modal-dialog-centered"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c(
                "div",
                {
                  staticClass: "m-scrollable",
                  attrs: {
                    "data-scrollbar-shown": "false",
                    "data-scrollable": "false",
                    "data-max-height": "800"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group m-form__group" },
                    [
                      [
                        _c("label", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")(_vm.image_capture)
                                )
                              ) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-6 col-sm-6 col-xs-6" },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "input-group-btn btn-file cursor-pointer float-left"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-brand",
                                        attrs: {
                                          disabled: false,
                                          type: "button"
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-upload" })]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        disabled: false,
                                        id: "file",
                                        name: "Imagen",
                                        type: "file",
                                        accept: ".png, .jpg"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.onFileChange($event)
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-brand btn-margin-left",
                                    attrs: { disabled: false, type: "button" },
                                    on: { click: _vm.showCam }
                                  },
                                  [_c("i", { staticClass: "fa fa-camera" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("file"),
                                        expression: "errors.has(`file`)"
                                      }
                                    ],
                                    staticClass: "m-form__help m--font-danger"
                                  },
                                  [_vm._v(_vm._s(_vm.errors.first("service")))]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-6 col-sm-6 col-xs-6 text-center"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-brand btn-margin-left float-right",
                                  attrs: { disabled: false, type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.restorePhoto()
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-undo" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-brand float-right",
                                  attrs: { disabled: false, type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.deletePhoto()
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-eraser" })]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.showCamera
                            ? _c(
                                "div",
                                { staticClass: "col-md-12 text-center" },
                                [
                                  _c("img", {
                                    staticClass: "img-thumbnail img-w min-150",
                                    attrs: { src: _vm.autho.images.file }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showCamera
                            ? _c(
                                "div",
                                { staticClass: "col-md-6 text-center" },
                                [
                                  _c("web-cam", {
                                    ref: "webcam",
                                    attrs: {
                                      "device-id": _vm.deviceId,
                                      width: "100%"
                                    },
                                    on: {
                                      started: _vm.onStarted,
                                      stopped: _vm.onStopped,
                                      error: _vm.onError,
                                      cameras: _vm.onCameras,
                                      "camera-change": _vm.onCameraChange
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.isCameraOn
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onCapture()
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-camera-retro"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger",
                                      attrs: { type: "button" },
                                      on: { click: _vm.onStop }
                                    },
                                    [_c("i", { staticClass: "fa fa-stop" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-success",
                                      attrs: { type: "button" },
                                      on: { click: _vm.onStart }
                                    },
                                    [_c("i", { staticClass: "fa fa-play" })]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showCamera
                            ? _c(
                                "div",
                                { staticClass: "col-md-6 text-center" },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm._f("translate")("image_capture")
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("figure", { staticClass: "figure" }, [
                                    _c("img", {
                                      staticClass:
                                        "img-thumbnail img-web-w min-150",
                                      attrs: { src: _vm.autho.images.file }
                                    })
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.closeForm }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm._f("capitalize")(_vm._f("translate")("close"))
                        ) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.autho.access_profile_id === "-1"
        ? _c(
            "s-modal",
            {
              attrs: {
                id: "access_profile_modal",
                title: _vm._f("capitalize")(
                  _vm._f("translate")("create_access_profile")
                )
              }
            },
            [
              _c("s-access-profile", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modal_access_day,
                    expression: "!modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  data: _vm.access_profile_view,
                  same_dates: _vm.same_dates,
                  auto: _vm.autho,
                  create_outside: true,
                  create_outside_group: false,
                  not_visualize: true,
                  view: false,
                  id_authType: "auth_form_wizard",
                  id_department: "department_form_wizard",
                  id_cancel: "btn-cancel-form-wizard",
                  id_control_point: "control_points",
                  access_profile_responsible: _vm.access_profile_responsible,
                  data_default: true
                },
                slot: "body"
              }),
              _vm._v(" "),
              _c("s-access-day", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modal_access_day,
                    expression: "modal_access_day"
                  }
                ],
                attrs: {
                  slot: "body",
                  open_outside: true,
                  view: false,
                  create_outside: true,
                  data: _vm.autho,
                  array_in_auth: true,
                  modal: true
                },
                slot: "body"
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "flaticon-suitcase" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3efe3d08", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3efe3d08","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/authorization/Edit.vue
// module id = 618
// module chunks = 0 1 11